import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import OfflineBanner from "./components/OfflineBanner";

import HomePage from "./pages/Home";
import OrganizationPage from "./pages/Organization";
import EventsPage from "./pages/Events";
import EventDetailPage from "./pages/EventDetail";
import NewsPage from "./pages/News";
import NewsDetailPage from "./pages/NewsDetail";
import MediaPage from "./pages/Media";
import WebTVPage from "./pages/WebTV";
import RadioPage from "./pages/Radio";
import ContactPage from "./pages/Contact";
import ConferencesPage from "./pages/Conferences";
import RegistrationPage from "./pages/Registration";
import RegistrationSuccessPage from "./pages/RegistrationSuccess";
import AdhesionPage from "./pages/Adhesion";

import MemberLoginPage from "./pages/MemberLogin";
import MemberDashboard from "./pages/MemberDashboard";
import MessagesPage from "./pages/Messages";
import AdminLoginPage from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ScanPage from "./pages/ScanPage";
import QuickRegisterPage from "./pages/QuickRegister";
import WelcomeScreenPage from "./pages/WelcomeScreen";
import ForgotPasswordPage from "./pages/ForgotPassword";
import ResetPasswordPage from "./pages/ResetPassword";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <OfflineBanner />
        <Routes>
          {/* Public site (with layout) */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/organisation" element={<OrganizationPage />} />
            <Route path="/evenements" element={<EventsPage />} />
            <Route path="/evenements/:slug" element={<EventDetailPage />} />
            <Route path="/actualites" element={<NewsPage />} />
            <Route path="/actualites/:slug" element={<NewsDetailPage />} />
            <Route path="/medias" element={<MediaPage />} />
            <Route path="/web-tv" element={<WebTVPage />} />
            <Route path="/radio" element={<RadioPage />} />
            <Route path="/conferences" element={<ConferencesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/adhesion" element={<AdhesionPage />} />
            <Route path="/i/:slug" element={<RegistrationPage />} />
            <Route path="/inscription-confirmee/:number" element={<RegistrationSuccessPage />} />
          </Route>

          {/* Auth pages (no layout) */}
          <Route path="/membres/connexion" element={<MemberLoginPage />} />
          <Route path="/admin/connexion" element={<AdminLoginPage />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

          {/* Protected */}
          <Route
            path="/membres"
            element={
              <ProtectedRoute>
                <MemberDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/membres/messages"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin", "responsable", "protocole", "securite", "communication", "media", "moderator"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/scan"
            element={
              <ProtectedRoute roles={["admin", "responsable", "protocole", "securite"]}>
                <ScanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/inscription-rapide"
            element={
              <ProtectedRoute roles={["admin", "responsable", "protocole", "securite"]}>
                <QuickRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/accueil"
            element={
              <ProtectedRoute roles={["admin", "responsable"]}>
                <WelcomeScreenPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
